export default __webpack_public_path__ + "static/media/Ies_Creston.1075b92a.png";